import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Divider,
  Grid,
  Group,
  LoadingOverlay,
  Modal,
  Paper,
  Tabs,
  Text,
  Title,
  Tooltip,
  UnstyledButton,
  useMantineTheme
} from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { getEncoding, encodingForModel } from "js-tiktoken";
import React, { useEffect, useRef, useState } from "react";
import {
  FaCheck,
  FaPhone,
  FaTrash
} from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import ActionForm from "../components/agents/action_form";
import Actions from "../components/agents/actions";
import AddActions from "../components/agents/add_actions";
import OthersPrompt from "../components/agents/others_prompt";
import OthersSettings from "../components/agents/others_settings";
import OthersVariables from "../components/agents/others_variables";
import Prompt from "../components/agents/prompt";
import Settings from "../components/agents/settings";
import Variables from "../components/agents/variables";
import AudioPlayer from "../components/audio_player";
import InputField, { InputFieldTypes } from "../components/input_field";
import useCallAgent from "../components/use_call_agent";
import { normalizeAgentLanguages, useAgentVariables, useApp } from "../contexts/app.context";
import { useAuth } from "../contexts/auth.context";
import { useLanguage } from "../contexts/language.context";
import { DELETE_AGENT, GET_AGENT_DETAILS, SAVE_AGENT } from "../services/agents";
import { GET_ALL_CALENDARS } from "../services/calendars";
import { TRIGGER_CALL } from "../services/calls";
import { GET_ALL_VOICES, GET_WORKSPACE_VOICES } from "../services/companies";
import { GET_ALL_KNOWLEDGES } from "../services/knowledges";
import { GET_ALL_PHONES, GET_ALL_WHATSAPPS } from "../services/phones";
import { GET_ALL_TAGS } from "../services/tags";
import { FaStop } from "react-icons/fa6";

const enc = getEncoding("gpt2");

export default function Agent({ }) {
  const { user: currentUser } = useAuth();
  const { userData } = useAuth();

  const navigate = useNavigate();
  const theme = useMantineTheme();

  const app = useApp();
  const { str } = useLanguage();
  const updateRef = useRef(false);

  const { id: agentId } = useParams();

  const utf8 = require("utf8");

  const [newCall, setNewCall] = useState<any>(null);
  const [data, setData] = useState<any>(null);
  const [action, setAction] = useState<any>(null);
  const [contacts, setContacts] = useState<any>([]);
  const [voice, setVoice] = useState<any>(null);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [loadingSave, setLoadingSave] = useState<boolean>(false);
  const [tags, setTags] = useState<any[]>([]);
  const [knowledges, setKnowledges] = useState<any[]>([]);
  const [voices, setVoices] = useState<any[]>([]);
  const [contactName, setContactName] = useState("");
  const [loadingDelete, setLoadingDelete] = React.useState({});
  const [loadingCall, setLoadingCall] = React.useState(false);
  const [playingTest, setPlayingTest] = React.useState(false);
  const [someUpdate, setSomeUpdate] = React.useState(false);
  const [phones, setPhones] = useState<any[]>([]);
  const [calendars, setCalendars] = React.useState<any[]>([]);
  const [selectedTab, setSelectedTab] = React.useState<string | null>("settings");

  const companyVariables = useAgentVariables();

  const [whatsapps, setWhatsapps] = useState<any[]>([]);
  const [loadingWhatsapps, setLoadingWhatsapps] = useState<boolean>(false);

  const [retellVoices, setRetellVoices] = useState<any[]>([]);

  const [playing, tooglePlay, loadingPlay] = useCallAgent({ own: !!data?.data?.own });

  const [tokensQt, setTokensQt] = useState(0);
  const tokensMax = 8192;

  const actionOptions = [
    {
      title: str("AGENTS.ACTIONS_OPTIONS.END_CALL_TITLE"),
      subtitle: str("AGENTS.ACTIONS_OPTIONS.END_CALL_SUBTITLE"),
      type: "end_call",
      description: str("AGENTS.ACTIONS_OPTIONS.END_CALL_DESCRIPTION"),
    },
    {
      title: str("AGENTS.ACTIONS_OPTIONS.TRANSFER_A_CALL_TITLE"),
      subtitle: str("AGENTS.ACTIONS_OPTIONS.TRANSFER_A_CALL_SUBTITLE"),
      type: "transfer_call",
      description: str("AGENTS.ACTIONS_OPTIONS.TRANSFER_A_CALL_DESCRIPTION"),
    },
    {
      title: str("AGENTS.ACTIONS_OPTIONS.SEND_SMS_TITLE"),
      subtitle: str("AGENTS.ACTIONS_OPTIONS.SEND_SMS_SUBTITLE"),
      type: "send_sms",
      description: str("AGENTS.ACTIONS_OPTIONS.SEND_SMS_DESCRIPTION"),
    },
    {
      title: str("AGENTS.ACTIONS_OPTIONS.INTEGRATION_TITLE"),
      subtitle: str("AGENTS.ACTIONS_OPTIONS.INTEGRATION_SUBTITLE"),
      type: "integration",
      description: "",
    },
    {
      title: str("AGENTS.ACTIONS_OPTIONS.BOOK_APPOINTMENT_TITLE"),
      subtitle: str("AGENTS.ACTIONS_OPTIONS.BOOK_APPOINTMENT_SUBTITLE"),
      type: "book_appointment",
      description: str("AGENTS.ACTIONS_OPTIONS.BOOK_APPOINTMENT_DESCRIPTION"),
    },
    {
      title: str("AGENTS.ACTIONS_OPTIONS.CALL_WEBHOOK_TITLE"),
      subtitle: str("AGENTS.ACTIONS_OPTIONS.CALL_WEBHOOK_SUBTITLE"),
      type: "call_webhook",
      // description: str("AGENTS.ACTIONS_OPTIONS.CALL_WEBHOOK_DESCRIPTION"),
    },
    {
      title: str("AGENTS.ACTIONS_OPTIONS.UNSUBSCRIBE_TITLE"),
      subtitle: str("AGENTS.ACTIONS_OPTIONS.UNSUBSCRIBE_SUBTITLE"),
      type: "unsubscribe",
      description: str("AGENTS.ACTIONS_OPTIONS.UNSUBSCRIBE_DESCRIPTION"),
    },
    {
      title: str("AGENTS.ACTIONS_OPTIONS.SCHEDULE_A_CALL_TITLE"),
      subtitle: str("AGENTS.ACTIONS_OPTIONS.SCHEDULE_A_CALL_SUBTITLE"),
      type: "schedule_a_call",
      description: str("AGENTS.ACTIONS_OPTIONS.SCHEDULE_A_CALL_DESCRIPTION"),
    },
    {
      title: str("AGENTS.ACTIONS_OPTIONS.PRESS_DIGIT_TITLE"),
      subtitle: str("AGENTS.ACTIONS_OPTIONS.PRESS_DIGIT_SUBTITLE"),
      type: "press_digit",
      description: str("AGENTS.ACTIONS_OPTIONS.PRESS_DIGIT_DESCRIPTION"),
    },
  ].filter(nn => nn);

  const loadPhones = () => {
    GET_ALL_PHONES()
      .then((res) => {
        setPhones(res)
      })
      .catch(err => {
        notifications.show({ title: "Ops.", message: err.message, color: 'red' })
      })
  }

  const loadCalendars = () => {
    GET_ALL_CALENDARS()
      .then(cs => {
        setCalendars(cs)
      })
      .catch(err => {
        notifications.show({ message: err.message, color: "red" })
      })
  }

  const loadData = (setLoading = true) => {
    if (agentId) {
      setLoadingData(setLoading);
      GET_AGENT_DETAILS(agentId)
        .then((dt) => {
          setLoadingData(false);
          setData(dt);
          if (!dt?.props?.retell_agent_id) setSomeUpdate(true);
          setTimeout(() => updateRef.current = true, 1000);
        })
        .catch((err) => {
          setLoadingData(false);
          notifications.show({ title: "Ops", message: err.message, color: "red", });
        });
    }
  };

  const loadTags = () => {
    GET_ALL_TAGS()
      .then(({ tags = [], categories = [] }) => {
        setTags(tags.map((t: { category: any; }) => ({ ...t, category: categories.find((c: { id: any; }) => c.id === t.category) })));
      })
      .catch(err => {
        notifications.show({ message: err.message, color: "red" })
      })
  }

  const loadKnowledges = () => {
    GET_ALL_KNOWLEDGES()
      .then(res => {
        setKnowledges(res);
      })
      .catch(err => {
        notifications.show({ message: err.message, color: "red" })
      })
  }

  const loadWhatsapps = () => {
    setLoadingWhatsapps(true);
    GET_ALL_WHATSAPPS()
      .then((res) => {
        setLoadingWhatsapps(false);
        setWhatsapps(res.filter((wpp: { configured: any; }) => wpp?.configured))
      })
      .catch(err => {
        setLoadingWhatsapps(false);
        notifications.show({ title: "Ops.", message: err.message, color: 'red' })
      })
  }

  const loadVoices = () => {
    // Try to use the new endpoint first (GET /voices)
    GET_WORKSPACE_VOICES()
      .then(res => {
        // Flatten default and workspace voices into a single array
        // for backward compatibility with the old voice list structure
        const allVoices = [
          ...(res.default_voices || []),
          ...(res.workspace_voices || [])
        ];
        
        // Map to expected format if needed
        const formattedVoices = allVoices.map((v: any) => ({
          voice_id: v.retell_voice_id,
          voice_name: v.name,
          preview_audio_url: v.preview_url,
          // Include original voice object for reference
          ...v
        }));
        
        setRetellVoices(formattedVoices);
      })
      .catch(err => {
        // Fallback to old endpoint for backward compatibility
        GET_ALL_VOICES()
          .then(res => {
            setRetellVoices(res ?? []);
          })
          .catch(fallbackErr => {
            notifications.show({ message: fallbackErr.message, color: "red" })
          })
      })
  }

  const handleCall = () => {
    setLoadingCall(true)
    TRIGGER_CALL({ ...newCall, agent: agentId })
      .then((dt) => {
        setLoadingCall(false)
        setNewCall(null);
      })
      .catch((err) => {
        setLoadingCall(false)
        notifications.show({ title: "Ops", message: err.message, color: "red" });
      });
  };

  const previewVoice = (url: string | undefined) => {
    let audio = new Audio(url);
    audio.play();
    setPlayingTest(true);
    audio.addEventListener("ended", function () {
      audio.currentTime = 0;
      setPlayingTest(false);
    });
  }

  const playTestVoice = () => {
    let audio = new Audio(`${process.env.REACT_APP_SERVER_URL}/auth/text/to/speech?text=${voice.testing}&voice_id=${voice.voice_id}`);
    audio.play();
    setPlayingTest(true);
    audio.addEventListener("ended", function () {
      audio.currentTime = 0;
      setPlayingTest(false);
    });
  }

  const handleSaveAgent = () => {
    if (agentId) {
      setLoadingSave(true);
      const params = {
        _id: agentId,
        ...data,
      };

      SAVE_AGENT(params)
        .then((dt) => {
          setLoadingSave(false);
          setSomeUpdate(false);
          updateRef.current = false;
          loadData();
          // notifications.show({ message: "Agent updated", color: "green" });
        })
        .catch((err) => {
          setLoadingSave(false);
          notifications.show({ title: "Ops", message: err.message, color: "red" });
        });
    }
  };

  useEffect(() => {
    setSomeUpdate(false);
    updateRef.current = false;
    loadData();
  }, [agentId]);

  useEffect(() => {
    const fullPrompt = (
      (data?.data?.company_info ?? "") +
      (data?.data?.objective ?? "") +
      (data?.data?.instructions ?? "") +
      normalizeAgentLanguages(data?.data?.retell?.agent?.language, ["en-US"]).join(", ") +
      (data?.data?.company_info ?? "") +
      (data?.data?.actions ?? []).reduce((pv: number, act: any) => pv + 20 + (act.description ?? ""), "") + (data?.data?.instructions_stack ?? []).reduce((pv: string, stack: any) => pv + `\n\n### ${stack.title}\n${(stack.instructions ?? []).map((inst: any) => `[${inst.title}] ${inst.description}`)}`, "")
    )
    setTokensQt(900 + enc.encode(fullPrompt).length);
  }, [data]);

  useEffect(() => {
    loadPhones();
    loadCalendars();
    loadTags();
    loadKnowledges();
    loadWhatsapps();
    loadVoices();
  }, []);

  useEffect(() => {
    if (updateRef.current) setSomeUpdate(true);
  }, [data]);

  return (
    <div>
      <LoadingOverlay visible={loadingData} />

      <Grid>
        <Grid.Col span={{ base: 12, md: 8 }}>
          <Paper>
            <Group p="lg">
              <Box style={{ flex: 1 }}>
                <Title order={3} c="gray.0">{data?.title}</Title>
                {/* <Badge>{data?.id}</Badge> */}
              </Box>
              {(userData?.user?.isAdmin || userData?.user?.whitelabelAdmin) && <Tooltip label="Template">
                <ActionIcon
                  variant={data?.template ? "filled" : "outline"}
                  color={data?.template ? "green" : "gray"}
                  onClick={() => setData((d: { template: any; }) => ({ ...d, template: !d?.template }))}
                ><FaCheck /></ActionIcon>
              </Tooltip>}
              <ActionIcon
                variant="outline"
                color="gray"
                size="md"
                onClick={() => {
                  app.confirmDialog(
                    {
                      text: "Are you sure about deleting this agent?",
                    },
                    ({ confirmed }) => {
                      if (confirmed) {
                        DELETE_AGENT(data?.id);
                        navigate("/agents");
                      }
                    }
                  );
                }}
              ><FaTrash /></ActionIcon>
            </Group>
            <Tabs color="gray.0" value={selectedTab ?? "general"} onChange={setSelectedTab}>
              <Tabs.List>
                <Tabs.Tab c="gray.1" value="settings">{str('SETTINGS')}</Tabs.Tab>
                {userData?.user?.promptingEnabled && <Tabs.Tab c="gray.1" value="prompt">{str('PROMPT')}</Tabs.Tab>}
                <Tabs.Tab c="gray.1" value="actions">{str('ACTIONS')}</Tabs.Tab>
                <Tabs.Tab c="gray.1" value="variables">{str('VARIABLES')}</Tabs.Tab>
              </Tabs.List>
            </Tabs>

            {selectedTab === "settings" && <Settings
              data={data}
              setData={setData}
              setVoice={setVoice}
              voices={retellVoices}
              knowledges={knowledges}
            />}

            {selectedTab === "prompt" && <Prompt
              data={data}
              setData={setData}
              companyVariables={companyVariables}
            />}

            {selectedTab === "variables" && <Variables
              data={data}
              setData={setData}
              companyVariables={companyVariables}
            />}

            {selectedTab === "actions" && <AddActions
              onSelect={setAction}
              whatsapps={whatsapps}
              calendars={calendars}
              actionOptions={actionOptions}
            />}

          </Paper>
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 4 }}>

          {selectedTab === "settings" && <Paper p="md" mb="md">
            <OthersSettings
              data={data}
              setData={setData}
              onUpdateAction={setAction}
            />
          </Paper>}

          {selectedTab === "variables" && <Paper p="md" mb="md">
            <OthersVariables
              data={data}
              setData={setData}
            />
          </Paper>}

          {selectedTab === "prompt" && <Paper p="md" mb="md">
            <OthersPrompt
              data={data}
              setData={setData}
              tags={tags}
              loadTags={loadTags}
            />
          </Paper>}

          {selectedTab === "actions" && <Paper p="md" mb="md">
            <Actions
              data={data}
              setData={setData}
              onUpdateAction={setAction}
              actionOptions={actionOptions}
            />
          </Paper>}

          <div style={{ position: 'fixed', display: 'flex', flexDirection: 'column', alignItems: 'center', bottom: 10, left: '10vw', right: '10vw' }}>
            {(tokensQt > tokensMax) && <Text fw="bold" c="red">Max. Tokens: {tokensQt}/{tokensMax}</Text>}
            <div style={{ display: 'flex', flexDirection: 'row', padding: 10 }}>
              {
                someUpdate
                  ? <Button
                    color="dark.5"
                    onClick={handleSaveAgent}
                    loading={loadingSave}
                    size="md"
                    style={{ minWidth: 360 }}
                  >{str("SAVE_UPDATES")}</Button>
                  : <>
                    <Button
                      disabled={!data?.props?.retell_agent_id}
                      // leftSection={playing ? <FaStop /> : <FaPlay />}
                      onClick={() => setNewCall({})}
                      variant="filled"
                      color="dark.6"
                      size="md"
                      style={{ minWidth: 180 }}
                    >{str("AGENTS.PHONE_CALL").toUpperCase()}</Button>
                    <Divider orientation="vertical" color="gray.0" />
                    <Button
                      disabled={!data?.props?.retell_agent_id}
                      loading={loadingPlay}
                      leftSection={playing ? <FaStop /> : null}
                      onClick={() => tooglePlay({ agentId: data.id })}
                      variant="filled"
                      color="dark.6"
                      size="md"
                      style={{ minWidth: 180 }}
                    >{playing ? str('STOP_CALL').toUpperCase() : str('WEB_CALL').toUpperCase()}</Button>
                  </>
              }
            </div>
          </div>
        </Grid.Col>
      </Grid>

      <Modal opened={!!action} onClose={() => setAction(null)} size="lg">
        <ActionForm
          data={action}
          setData={setAction}
          calendars={calendars}
          loadCalendars={loadCalendars}
          loadWhatsapps={loadWhatsapps}
          whatsapps={whatsapps}
          extractVariables={data?.data?.extract_variables}
        />
        <Group justify="flex-end" mt="lg">
          <Button onClick={() => {
            setData((d: { data: { actions: any; }; }) => ({
              ...d, data: {
                ...d.data,
                actions: [undefined, null].includes(action.index)
                  ? [
                    ...(d?.data?.actions ?? []),
                    {
                      ...action,
                      index: (d?.data?.actions ?? []).length,
                    }
                  ]
                  : (d?.data?.actions ?? []).map((act: any, i: any) => (
                    action.index === i
                      ? { ...act, ...action }
                      : act
                  ))
              }
            }))
            setAction(null);
          }}>{str("SAVE")}</Button>
        </Group>
      </Modal>

      <Modal opened={!!newCall} onClose={() => setNewCall(null)} size="sm">
        <InputField
          name="from"
          title={str("AGENTS.PHONE_NUMBER_FROM")}
          mb="md"
          value={newCall?.from}
          fieldType={InputFieldTypes.SELECT}
          options={phones
            .filter(p => (
              p.type === "sip" ||
              ["in-use", "success"].includes(p?.data?.twilio?.status) ||
              p?.data?.telnyx?.status
            ))
            .map(p => ({ label: p.number, value: p.id }))}
          onChange={({ from }) => setNewCall((na: any) => ({ ...na, from }))}
        />

        {/* <InputField
          value={newCall?.contact}
          name="contact"
          mb="md"
          title="Contact"
          fieldType={InputFieldTypes.SELECT}
          onChange={({contact}) => setNewCall(nc => ({...nc, contact}))}
          options={contacts.map(c => ({value: c.id, label: c.name}))}
        /> */}
        <InputField
          name="contact"
          title={str("CONTACTS.TITLE")}
          mt="md"
          value={newCall?.contact}
          onChange={({ contact }) => {
            setNewCall((nc: any) => ({ ...nc, contact }));
          }}
          fieldType={InputFieldTypes.SEARCH}
          searchType="contact"
        />
        <Button mt="md" loading={loadingCall} onClick={handleCall}>{str("CALL_NOW")}</Button>
      </Modal>

      <Modal
        opened={!!voice}
        onClose={() => setVoice(null)}
        size="lg"
      >
        {retellVoices.map(rv => <>
          <Paper p="xs">
            <Group>
              <AudioPlayer url={rv.preview_audio_url} />
              <Box style={{ flex: 1 }}>
                <Text>{rv.voice_name}</Text>
                <Group gap={5}>
                  <Badge size="xs" variant="outline" color={rv.gender === "female" ? "pink" : "blue"}>{rv.gender}</Badge>
                  {rv.voice_type === "custom" && <Badge size="xs" variant="outline" color="yellow">{rv.voice_type}</Badge>}
                  {rv.age && <Badge size="xs" variant="outline" color="cyan">{rv.age}</Badge>}
                  {rv.accent && <Badge size="xs" variant="outline" color="lime">{rv.accent}</Badge>}
                </Group>
              </Box>
              <UnstyledButton
                onClick={() => {
                  setVoice(null);
                  setData((na: { data: { retell: { agent: any; }; }; }) => ({
                    ...na, data: {
                      ...na.data, retell: {
                        ...na?.data?.retell, agent: { ...na?.data?.retell?.agent, voice_id: rv.voice_id }
                      }
                    }
                  }));
                }}
              >
                <Text size="xs">{str("AGENTS.APPLY_THIS_VOICE")}</Text>
              </UnstyledButton>
            </Group>
          </Paper>
          <Divider mt="xs" mb="xs" />
        </>)}
      </Modal>
    </div>
  );
}